import { render, staticRenderFns } from "./BaseTaxonomyCrud.vue?vue&type=template&id=ae5674f4"
import script from "./BaseTaxonomyCrud.vue?vue&type=script&lang=js"
export * from "./BaseTaxonomyCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports